<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
const $config = useRuntimeConfig()
const { locale } = useI18n()
const i18nHead = useLocaleHead({
  addSeoAttributes: true
})

useHead(
  {
    link: [
      {
        rel: 'icon',
        type: 'image/svg',
        href: `${$config.public.app.staticCdnEndpoint}/favicons/favicon.svg`
      },
      ...(i18nHead.value.link || [])
    ],
    htmlAttrs: {
      lang: i18nHead.value?.htmlAttrs?.lang || locale.value
    },
    meta: [...(i18nHead.value.meta || [])]
  },
  {
    mode: 'server'
  }
)
</script>
